export default __webpack_public_path__ + "static/media/Radiant_product.acb4ada7.png";